module.exports = __webpack_public_path__ + "assets/img/logo-tabbar.3b3ebb23.png";